import React, { useRef, useEffect } from 'react';
import { useGLTF } from '@react-three/drei';
import { MeshBasicMaterial, TextureLoader } from 'three';

export default function Model(props) {
  const group = useRef();
  const earth = useRef();
  const ring = useRef();
  const ring1 = useRef();
  const ring2 = useRef();
  const { nodes, materials } = useGLTF('/objects/globe.glb');
  const material = new MeshBasicMaterial({map: new TextureLoader().load('/objects/textures/night.jpg')});

  useEffect(() => {
      setInterval(() => {
        if(!ring.current) return;
        
        ring.current.rotateY(0.005);
        ring1.current.rotateX(-0.005);
        ring2.current.rotateX(0.005);
      }, 10);
  }, []);

  return (
    <group ref={group} {...props} dispose={null} position={[-.5,-2.5,1.5]}>
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <group rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
          <group ref={ring1} position={[-37.06, 149.76, -53.95]} rotation={[0.17, -0.64, -0.32]}>
            <mesh geometry={nodes['Tube_1_����������_0'].geometry} material={nodes['Tube_1_����������_0'].material} />
          </group>
          <group ref={earth} position={[-36.88, -46.73, -54.47]} rotation={[-Math.PI / 2, 0, -3.05]} scale={90}>
            <mesh geometry={nodes['����������_Material002_0'].geometry} material={material} />
          </group>
          <group ref={ring} name="Sphere" position={[-36.88, -46.56, -54.47]} rotation={[Math.PI, 1.09, -Math.PI]} scale={1.1}>
            <mesh geometry={nodes.Sphere_Mat1_0.geometry} material={materials['Mat.1']} />
          </group>
          <group position={[498.08, 222.94, 444.85]} rotation={[Math.PI, 0.76, 2.97]} />
          <group ref={ring2} position={[-37.06, 149.76, -53.95]} rotation={[1, -0.82, 0.84]}>
            <mesh geometry={nodes['Tube_����������_0'].geometry} material={nodes['Tube_����������_0'].material} />
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/objects/globe.glb');